export default __webpack_public_path__ + "static/media/refresh_space.f0de2194.svg";